/** Keyboard-shortcut bindings are stored as normalized "chord" strings so a
 *  binding can include a modifier (e.g. undo = `mod+z`). `mod` means Ctrl OR ⌘
 *  (whichever the platform uses); plain single keys have no prefix (e.g. `n`).
 *  Shift is NOT encoded — `e.key` already reflects it (e.g. `?`). */

interface ChordEvent {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  altKey: boolean;
}

/** Build the normalized chord for a keyboard event. */
export function chordFromEvent(e: ChordEvent): string {
  const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
  const parts: string[] = [];
  if (e.ctrlKey || e.metaKey) parts.push("mod");
  if (e.altKey) parts.push("alt");
  parts.push(key);
  return parts.join("+");
}

/** Human-readable form of a chord, e.g. `mod+z` → "Ctrl/⌘ + Z". */
export function formatChord(chord: string): string {
  return chord
    .split("+")
    .map((p) => (p === "mod" ? "Ctrl/⌘" : p === "alt" ? "Alt" : p === " " ? "Space" : p.length === 1 ? p.toUpperCase() : p))
    .join(" + ");
}
